import React, { useState, useEffect } from "react";
import { Loader, Table, Menu, Button, Icon, Divider } from "semantic-ui-react";
import { size, map, debounce } from "lodash";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { RoleItem } from "../RoleItem";
import { RoleForm } from "../RoleForm";
import { BasicModal } from "../../../Shared";
import { useLanguage } from "../../../../contexts";
import { isAdmin, isMaster } from "../../../../utils/checkPermission";
import searchSvg from "../../../../assets/svg/search.svg";
import "./ListRoles.scss";

const roleController = new Role();

export function ListRoles(props) {
  const { reload, onReload } = props;
  const [roles, setRoles] = useState(null);
  const [rolesFilter, setRolesFilter] = useState([]);
  const [rolesActive, setRolesActive] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const { accessToken, user: { role } } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const onOpenCloseModal = () => setShowModal((prev) => !prev);

  useEffect(() => {
    (async () => {
      try {
        setRoles(null);
        setRolesFilter([]);
        const response = await roleController.getRoles(accessToken, rolesActive);
        const result = response.map((r) => ({ ...r, key: r._id }));
        setRoles(result);
        setRolesFilter(result);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [rolesActive, reload, accessToken]);

  return (
    <div className="roles-list">
      {/* Tabs activos / inactivos */}
      <Menu secondary pointing>
        <Menu.Item
          name={t("active_roles")}
          active={rolesActive}
          onClick={() => setRolesActive(true)}
        />
        <Menu.Item
          name={t("inactive_roles")}
          active={!rolesActive}
          onClick={() => setRolesActive(false)}
        />
      </Menu>

      {/* Buscador + botón plus */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" , marginTop:"3rem"}}>
        <SearchStandardRole
          dataOrigin={roles || []}
          setData={setRolesFilter}
          t={t}
        />
        {(isMaster(role) || isAdmin(role)) && (
          <Button icon className="add-role-btn" onClick={onOpenCloseModal} style={{ marginLeft: "auto" }}>
            <Icon name="plus" />
          </Button>
        )}
      </div>

      <Divider clearing />

      {/* Contenido */}
      {!roles ? (
        <Loader active inline="centered" />
      ) : size(rolesFilter) === 0 ? (
        <p>{t("there_is_no_role")}</p>
      ) : (
        <Table className="roles-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t("name")}</Table.HeaderCell>
              <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {map(rolesFilter, (r) => (
              <RoleItem key={r._id} role={r} onReload={onReload} />
            ))}
          </Table.Body>
        </Table>
      )}

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("create_new_role")}
        size="tiny"
      >
        <RoleForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </div>
  );
}

function SearchStandardRole({ dataOrigin, setData, t }) {
  const handleSearchChange = debounce((value) => {
    if (!value) {
      setData(dataOrigin);
      return;
    }
    const filtered = dataOrigin.filter((item) =>
      Object.values(item).some((v) =>
        v.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setData(filtered);
  }, 300);

  return (
    <div className="search-user-wrapper">
      <img src={searchSvg} alt="search" className="search-user-icon" />
      <input
        className="search-user-input"
        placeholder={t("search")}
        onChange={(e) => handleSearchChange(e.target.value)}
      />
    </div>
  );
}
